import React, { useState } from 'react';
import RightNavBar from './RightNavBar';
import InfoCard from './InfoCard';
import FilterList from './FilterList';
import './Experience.css';
import Carousel, { consts } from 'react-elastic-carousel';
import "react-multi-carousel/lib/styles.css";
import "./Projects.css";

function Projects() {
    const breakPointsMin = [
        { width: 1, itemsToShow: 1 },
        { width: 400, itemsToShow: 3, itemsToScroll: 3 },
    ];

    const breakPointsMax = [
        { width: 1, itemsToShow: 1 },
        { width: 400, itemsToShow: 2, itemsToScroll: 2 },
    ];

    let resetTimeout;

    // computer graphics polytech 2
    const cgPoly2Content = (
        <>
            <div className="bio">

            I implemented a color matching algorithm using the sliced optimal transport
            approach.

            </div>
            <img src="/images/imageproc1.png" alt="image processing project" className="presentation-img" />
            <img src="/images/imageproc2.png" alt="image processing project" className="presentation-img" />
        </>
    );
    const cgPoly2Card = <InfoCard 
        headerBio="Image Processing (C++)"
        content={cgPoly2Content} 
        tag="C++"
    />;

    // computer graphics polytech 1
    const cgPolyImages = ["images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png", "images/graphics1.png", "images/graphics2.png", "images/graphics3.png", "images/graphics4.png"];
    const cgPolyContent = (
        <>
            <div className="bio">

            I built a ray tracer from scratch in C++. experimenting with diffuse and transparent
            objects, as well as mirrors. I implemented both direct and indirect lighting and
            added spherical lighting later on. Several corrections were applied, such as gamma
            corrections and antialiasing.

            </div>
            <div className="carousel-container">
                <Carousel 
                    breakPoints={breakPointsMax}
                    enableAutoPlay={true}
                    autoPlaySpeed={6000}
                    transitionMs={1000}
                    pagination={false}
                    itemPosition={consts.START}
                >
                    {cgPolyImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const cgPolyMoreInfo = ["Diffuse, transparent objects and mirrors", "Direct and indirect lighting (+ spherical)", "Gamma correction", "Antialiasing"];
    const cgPolyCard = <InfoCard 
        headerBio="Ray Tracer (C++)"
        content={cgPolyContent} 
        tag="C++"
        more={<ul>{cgPolyMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features"
    />;

    // shaders 
    const shadersImages = ["images/check.png", "images/texture.png", "images/normal2.png", "images/gouraud.png", "images/texture2.png", "images/toon3.png", "images/check.png", "images/texture.png", "images/normal2.png", "images/gouraud.png", "images/texture2.png", "images/toon3.png", "images/check.png", "images/texture.png", "images/normal2.png", "images/gouraud.png", "images/texture2.png", "images/toon3.png", "images/check.png", "images/texture.png", "images/normal2.png", "images/gouraud.png", "images/texture2.png", "images/toon3.png", "images/check.png", "images/texture.png", "images/normal2.png", "images/gouraud.png", "images/texture2.png", "images/toon3.png", "images/check.png", "images/texture.png", "images/normal2.png", "images/gouraud.png", "images/texture2.png", "images/toon3.png"];
    const shadersContent = (
        <>
            <div className="bio">

            I built different shaders, such as: Phong, Gouraud, texture-modulated, toon,
            and normal map.

            </div>
            <div className="carousel-container">
                <Carousel itemPosition={consts.START} breakPoints={breakPointsMax} enableAutoPlay={true} autoPlaySpeed={6000} transitionMs={1000} pagination={false}>
                    {shadersImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const shadersMoreInfo = ["Phong shader", "Gouraud shader", "Texture-modulated shader", "Toon shader", "Normal map shader", "Function-modulated shader (checkerboard)"];
    const shadersCard = <InfoCard 
        headerBio="Shaders (Java + OpenGL)"
        content={shadersContent} 
        tag="Java"
        more={<ul>{shadersMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features"
    />;

    // Ray Trecer (java)
    const rayTracerImages = ["images/cbox-direct.xml.png", "images/cbox-global.xml.png", "images/cbox-RR.xml.png", "images/new-scene1.xml_direct.png", "images/new-scene1.xml_global.png", "images/new-scene1.xml_RR.png", "images/new-scene3.xml_direct.png", "images/new-scene3.xml_global.png", "images/new-scene3.xml_RR.png", "images/cbox-direct.xml.png", "images/cbox-global.xml.png", "images/cbox-RR.xml.png", "images/new-scene1.xml_direct.png", "images/new-scene1.xml_global.png", "images/new-scene1.xml_RR.png", "images/new-scene3.xml_direct.png", "images/new-scene3.xml_global.png", "images/new-scene3.xml_RR.png", "images/cbox-direct.xml.png", "images/cbox-global.xml.png", "images/cbox-RR.xml.png", "images/new-scene1.xml_direct.png", "images/new-scene1.xml_global.png", "images/new-scene1.xml_RR.png", "images/new-scene3.xml_direct.png", "images/new-scene3.xml_global.png", "images/new-scene3.xml_RR.png", "images/cbox-direct.xml.png", "images/cbox-global.xml.png", "images/cbox-RR.xml.png", "images/new-scene1.xml_direct.png", "images/new-scene1.xml_global.png", "images/new-scene1.xml_RR.png", "images/new-scene3.xml_direct.png", "images/new-scene3.xml_global.png", "images/new-scene3.xml_RR.png", "images/cbox-direct.xml.png", "images/cbox-global.xml.png", "images/cbox-RR.xml.png", "images/new-scene1.xml_direct.png", "images/new-scene1.xml_global.png", "images/new-scene1.xml_RR.png", "images/new-scene3.xml_direct.png", "images/new-scene3.xml_global.png", "images/new-scene3.xml_RR.png", "images/cbox-direct.xml.png", "images/cbox-global.xml.png", "images/cbox-RR.xml.png", "images/new-scene1.xml_direct.png", "images/new-scene1.xml_global.png", "images/new-scene1.xml_RR.png", "images/new-scene3.xml_direct.png", "images/new-scene3.xml_global.png", "images/new-scene3.xml_RR.png"];
    const rayTracerContent = (
        <>
            <div className="bio">

            I implemented a ray tracing algorithm in Java (direct and indirect lighting, as
            well as the Russian Roulette algorithm).

            </div>
            <div className="carousel-container">
                <Carousel itemPosition={consts.START} breakPoints={breakPointsMin} enableAutoPlay={true} autoPlaySpeed={6000} transitionMs={1000} pagination={false}>
                    {rayTracerImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const rayTracerMoreInfo = ["Direct lighting", "Global lighting", "Russian Roulette algorithm"];
    const rayTracerCard = <InfoCard 
        headerBio="Ray Tracer (Java + OpenGL)"
        content={rayTracerContent} 
        tag="Java"
        more={<ul>{rayTracerMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features" 
    />;

    // geometry processing
    const gpImages = ["images/vertex-removal-0.png", "images/vertex-removal-1.png", "images/vertex-removal-2.png", "images/edge-removal-1.png", "images/edge-removal-3.png", "images/sphere_after.png", "images/vertex-removal-0.png", "images/vertex-removal-1.png", "images/vertex-removal-2.png", "images/edge-removal-1.png", "images/edge-removal-3.png", "images/sphere_after.png", "images/vertex-removal-0.png", "images/vertex-removal-1.png", "images/vertex-removal-2.png", "images/edge-removal-1.png", "images/edge-removal-3.png", "images/sphere_after.png", "images/vertex-removal-0.png", "images/vertex-removal-1.png", "images/vertex-removal-2.png", "images/edge-removal-1.png", "images/edge-removal-3.png", "images/sphere_after.png", "images/vertex-removal-0.png", "images/vertex-removal-1.png", "images/vertex-removal-2.png", "images/edge-removal-1.png", "images/edge-removal-3.png", "images/sphere_after.png", "images/vertex-removal-0.png", "images/vertex-removal-1.png", "images/vertex-removal-2.png", "images/edge-removal-1.png", "images/edge-removal-3.png", "images/sphere_after.png"];
    const gpContent = (
        <>
            <div className="bio">

            I coded the Half-Edge data structure for building a triangle mesh, which I then
            used in several geometry processing algorithms: edge removal, vertex removal, and
            Garland and Heckber’s mesh simplification.

            </div>
            <div className="carousel-container">
                <Carousel itemPosition={consts.START} breakPoints={breakPointsMax} enableAutoPlay={true} autoPlaySpeed={6000} transitionMs={1000} pagination={false}>
                    {gpImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const gpMoreInfo = ["Half-edge data structure", "Vertex removal", "Edge removal", "Garland and Heckber's mesh simplification algorithm"];
    const gpCard = <InfoCard 
        headerBio="Geometry Processing (Java + OpenGL)"
        content={gpContent} 
        tag="Java"
        more={<ul>{gpMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features"
    />;

    // SparkleJump
    const sparkleImages = ["images/sparkle_menu.jpg", "images/sparkle_play.jpg", "images/sparkle_shop.jpg", "images/sparkle_rules.jpg", "images/sparkle_menu.jpg", "images/sparkle_play.jpg", "images/sparkle_shop.jpg", "images/sparkle_rules.jpg", "images/sparkle_menu.jpg", "images/sparkle_play.jpg", "images/sparkle_shop.jpg", "images/sparkle_rules.jpg", "images/sparkle_menu.jpg", "images/sparkle_play.jpg", "images/sparkle_shop.jpg", "images/sparkle_rules.jpg", "images/sparkle_menu.jpg", "images/sparkle_play.jpg", "images/sparkle_shop.jpg", "images/sparkle_rules.jpg", "images/sparkle_menu.jpg", "images/sparkle_play.jpg", "images/sparkle_shop.jpg", "images/sparkle_rules.jpg"];
    const sparkleContent = (
        <>
            <div className="bio">

            Sparkle Jump is an infinite platformer game that I developed and designed
            from scratch. It has features such as power-ups (which offer speed and immunity),
            enemies, platforms that move and disappear, and a shop with multiple players. You
            can see more on Google Play <a href="https://play.google.com/store/apps/details?id=com.SparklesInc.SparkleJump" target="_blank" className="bio-link bold-element">here</a>.

            </div>
            <div className="carousel-container">
                <Carousel itemPosition={consts.START} breakPoints={breakPointsMin} enableAutoPlay={true} autoPlaySpeed={6000} transitionMs={1000} pagination={false}>
                    {sparkleImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const sparkleMoreInfo = ["Moving platforms", "Breakable platforms", "Power-ups (speed & immunity)", "Collectibles", "Store"];
    const sparkleCard = <InfoCard 
        headerBio="Sparkle Jump - Infinite Platformer Game (C#)"
        content={sparkleContent} 
        tag="C#"
        more={<ul>{sparkleMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features" 
    />;

    // Hackathon
    const hackImages = ["images/gallery (1).jpg", "images/gallery.jpg"];
    const hackContent = (
        <>
            <div className="bio">

            As part of the HackDartmouth 2021 hackathon, my team built a 3D game meant
            to educate new drivers. Players have the chance to learn about essential driving
            rules during the game and receive feedback for improvements. Additionally, there
            will be pop-up questions to test players’ driving knowledge and their scores will
            determine their current driving skills. We based the rules of our game on the MVD
            Driving Manual. See more <a href="https://devpost.com/software/headsup-1i2hgu" target="_blank" className="bio-link bold-element">here</a>.

            </div>
            <div className="image-container">{hackImages.map(img => <img src={img} alt="hackathon project"/>)}</div>
        </>
    );
    const hackMoreInfo = ["Keyboard control", "Road sign detection", "Ability to signal (blinkers)", "Multiple choice, driver exam-type questions for every mistake"];
    const hackCard = <InfoCard 
        headerBio="HeadsUp - HackDartmouth Winner of the Most Contrarian Prize (C#)"
        content={hackContent} 
        tag="C#"
        more={<ul>{hackMoreInfo.map((item, index) => <li className="more-info-items" key={index}><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features" 
    />;

    // mosaic app 
    const mosaicImages = ["images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png", "images/panorama1.png", "images/panorama2.png"];
    const mosaicContent = (
        <>
            <div className="bio">

            I built an image mosaicking app that stitches a collection of photos into a mosaic.

            </div>
            <div className="carousel-container">
                <Carousel itemPosition={consts.START} enableAutoPlay={true} autoPlaySpeed={6000} transitionMs={1000} pagination={false}>
                    {mosaicImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const mosaicMoreInfo = ["Compute homography between a pair of images", "Apply homography to a set of points", "Warp an image (and its inverse computation)", "Use RANSAC for homography outliers", "Blend two images into one (with weighted sums)", "Use previous operations to stitch images into a mosaic"];
    const mosaicCard = <InfoCard 
        headerBio="Image Mosaicking App"
        content={mosaicContent} 
        tag="MATLAB"
        more={<ul>{mosaicMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features"
    />;

    // line finder
    const lineImages = ["images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png", "images/line_hough_3.png", "images/line_hough_2.png", "images/line_hough_1.png"];
    const lineContent = (
        <>
            <div className="bio">

            I developed a program that recognizes lines in an image using the Hough Transform.

            </div>
            <div className="carousel-container">
                <Carousel itemPosition={consts.START} breakPoints={breakPointsMax} enableAutoPlay={true} autoPlaySpeed={6000} transitionMs={1000} pagination={false}>
                    {lineImages.map(img => <div className="carousel-img"><img src={img}/></div>)}
                </Carousel>
            </div>
        </>
    );
    const lineMoreInfo = ["Find edge pixels in an image", "Implement Hough Transform"];
    const lineCard = <InfoCard 
        headerBio="Line Finder"
        content={lineContent} 
        tag="MATLAB"
        more={<ul>{lineMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features"
    />;

    // 2d object recognition
    const objImages = ["images/testing1c1_many_objects_1.png", "images/testing1c1_many_objects_2.png"];
    const objContent = (
        <>
            <div className="bio">

            I developed a vision system that recognizes two-dimensional objects in images. In the figure below, you can observe the annotated objects recognized as the common objects between the two images. The program 
            also computes the object orientation and position.

            </div>
            <div className="image-container">{objImages.map(img => <img src={img} alt="2d object recognition project"/>)}</div>
        </>
    );
    const objMoreInfo = ["Convert an image to a binary image and segment it into connected regions", "Given a labeled image, compute properties for each object (center position, minimum moment of inertia, orientation, roundness)", "Compare properties of different objects to recognize them"];
    const objCard = <InfoCard 
        headerBio="2D Object Recognition System"
        content={objContent} 
        tag="MATLAB"
        more={<ul>{objMoreInfo.map((item, index) => <li key={index} className="more-info-items"><i className="fa fa-angle-right" />  {item}</li>)}</ul>}
        moreInfo="Features"
    />;

    const projectsFilter = {
        "All": [mosaicCard, lineCard, objCard, cgPolyCard, cgPoly2Card, shadersCard, rayTracerCard, gpCard, sparkleCard, hackCard],
        "Computer Graphics": [cgPolyCard, cgPoly2Card, shadersCard, rayTracerCard, gpCard],
        "Computer Vision": [mosaicCard, lineCard, objCard],
        "Game Development": [sparkleCard, hackCard],
        "Group Projects": [hackCard],
        "Individual Projects": [mosaicCard, lineCard, objCard, cgPolyCard, cgPoly2Card, shadersCard, rayTracerCard, gpCard, sparkleCard],
        "School Projects": [mosaicCard, lineCard, cgPolyCard, cgPoly2Card, shadersCard, rayTracerCard, gpCard],
        "Extracurricular Projects": [sparkleCard, hackCard],
        "C#": [sparkleCard, hackCard],
        "C++": [cgPolyCard, cgPoly2Card],
        "Java": [shadersCard, rayTracerCard, gpCard],
        "OpenGL": [shadersCard, rayTracerCard, gpCard],
        "MATLAB" : [mosaicCard, lineCard, objCard]
    }
    const filters = Object.keys(projectsFilter);

    const [ filter, setFilter ] = useState("All");
    const chooseFilter = (item) => {
        setFilter(item);
    }

    return (
        <>
            <div className="page-content">
                {projectsFilter[filter]}
            </div>
            <RightNavBar>
                <div className="question-caption italic-element">
                    Click to filter the results:
                </div>
                <FilterList filters={filters} onFilterClick={chooseFilter} key="proj-filter"/>
            </RightNavBar>
        </>
    )
}

export default Projects;